import { useEffect, useState } from 'react';
import './ArenaMatchmaking.css';

const TIP_INTERVAL_MS = 6000;
const TIPS = [
  'Каждую карту можно сыграть только один раз. Выбирайте момент для атаки.',
  'Смотрите не только на урон: модификатор карты тоже влияет на бой.',
  'Карты соперника скрыты. Следите за его ходами и эффектами на поле.',
  'Перед боем проверьте все пять карт в колоде — каждая пригодится.',
];

export function ArenaMatchmaking({ queued, connected, elapsed, busy, onCancel, onStart }) {
  const [tipIndex, setTipIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => setTipIndex(index => (index + 1) % TIPS.length), TIP_INTERVAL_MS);
    return () => window.clearInterval(timer);
  }, []);

  return <section className="arena-matchmaking" aria-label="Поиск соперника">
    <div className="arena-matchmaking-main">
      <div className="arena-matchmaking-art-scene">
        <img className="arena-matchmaking-art" src="/arena-matchmaking-halloween.webp" alt="" width="1254" height="1254" fetchPriority="high" />
        <div className="arena-matchmaking-particles" aria-hidden="true">{Array.from({ length: 8 }, (_, index) => <i key={index} />)}</div>
      </div>
      <div className="arena-matchmaking-season">HALLOWEEN</div>
      <h2>{queued ? 'Ищем соперника' : 'Подключаем арену'}</h2>
      <div className="arena-matchmaking-status" role="status">
        <span className="arena-matchmaking-spinner" aria-hidden="true" />
        {queued ? 'Подбираем достойного противника' : 'Готовим поле для боя'}
      </div>
      {queued && <div className="arena-matchmaking-time" aria-live="off">В поиске <b>{elapsed} сек.</b></div>}
    </div>
    <aside className="arena-matchmaking-tip" aria-label="Советы перед боем">
      <div className="arena-matchmaking-tip-heading"><span>СОВЕТ ПЕРЕД БОЕМ</span><span aria-hidden="true">{tipIndex + 1} / {TIPS.length}</span></div>
      <p key={tipIndex}>{TIPS[tipIndex]}</p>
      <div className="arena-matchmaking-tip-dots" aria-hidden="true">{TIPS.map((_, index) => <i key={index} className={index === tipIndex ? 'active' : ''} />)}</div>
    </aside>
    {(queued || connected) && <button type="button" className="arena-matchmaking-cancel" disabled={busy} onClick={queued ? onCancel : onStart}>
      {busy ? (queued ? 'Отменяем…' : 'Подключаем…') : queued ? 'Отменить поиск' : 'Начать поиск'}
    </button>}
  </section>;
}
